<template>
  <div class="stu-page">
    <van-nav-bar :title="className" left-arrow @click-left="goBack" fixed placeholder />

    <div class="stu-list" v-if="list.length > 0">
      <div class="stu-item" v-for="s in list" :key="s.id">
        <div class="stu-info">
          <div class="stu-name-row">
            <span class="stu-name">{{ s.name }}</span>
            <!-- <span class="stu-meta">{{ s.grade }}</span> -->
            <van-tag
              v-if="s.leave_id"
              :type="leaveStatusType(s.leave_status)"
              plain
              size="medium"
            >
              {{ leaveStatusText(s.leave_status) }}
            </van-tag>
          </div>
          <!-- ponytail: 依赖 studentList 返回 joined_classes:[{id,class_name}]；字段未就绪时整行标签不显示 -->
          <div class="stu-classes">
            <template v-if="s.joined_classes && s.joined_classes.length">
              <van-tag
                v-for="c in s.joined_classes"
                :key="c.id"
                type="primary"
                plain
                size="medium"
                >{{ c.class_name }}</van-tag
              >
            </template>
            <!-- <span v-else class="stu-meta">未报兴趣班</span> -->
          </div>
        </div>
        <div class="stu-actions">
          <van-button class="leave-btn" size="small" @click="toLeave(s)">请假</van-button>
          <van-button v-if="s.leave_id" class="cancel-btn" size="small" @click="cancel(s)"
            >取消请假</van-button
          >
          <van-button class="manage-btn" size="small" @click="toClassManage(s)"
            >报班管理</van-button
          >
        </div>
      </div>
    </div>

    <van-empty v-else description="暂无学生" />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Toast, Dialog } from "vant";
import api from "../service/api";
import { leaveStatusText, leaveStatusType } from "../utils/leaveStatus";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const className = route.query.className || "班级学生";
    const list = ref([]);

    const load = async () => {
      try {
        Toast.loading({ message: "加载中...", forbidClick: true });
        const res = await api.getStudentList({
          sid: localStorage.getItem("sid"),
          class_id: route.query.classId,
        });
        Toast.clear();
        if (res.data.code == 1001) {
          list.value = res.data.result || [];
        } else {
          Toast(res.data.message);
        }
      } catch (error) {
        Toast.clear();
        Toast("获取学生列表失败");
      }
    };

    const toLeave = (s) => {
      router.push({
        path: "/leaveApply",
        query: { studentId: s.id, studentName: s.name },
      });
    };

    const toClassManage = (s) => {
      router.push({
        path: "/studentClassManage",
        query: { studentId: s.id, studentName: s.name },
      });
    };

    // 取消请假：复用 recordLeave（status=3=取消），与家长端 LeaveList 取消逻辑一致
    const cancel = (s) => {
      Dialog.confirm({
        title: "取消请假",
        message: "确定取消 " + s.name + " 的请假吗？",
      })
        .then(async () => {
          try {
            Toast.loading({ message: "处理中...", forbidClick: true });
            const res = await api.recordLeave({
              user_id: sessionStorage.getItem("userId"),
              student_leave_id: s.leave_id,
              content: "",
              status: "3",
            });
            Toast.clear();
            if (res.data.code == 1001) {
              s.leave_id = null;
              s.leave_status = 3;
              Toast.success("已取消请假");
            } else {
              // 后端明确返回失败：不假装成功，避免 UI 与服务器状态不一致
              Toast(res.data.message || "取消失败");
            }
          } catch (error) {
            Toast.clear();
            Toast("取消失败，请重试");
          }
        })
        .catch(() => {});
    };

    const goBack = () => router.back();

    onMounted(() => {
      load();
    });

    return {
      className,
      list,
      toLeave,
      toClassManage,
      cancel,
      leaveStatusText,
      leaveStatusType,
      goBack,
    };
  },
};
</script>

<style lang="less" scoped>
.stu-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding-bottom: 20px;
}

.stu-list {
  padding: 6px 14px 14px;
}

.stu-item {
  margin-bottom: 14px;
  padding: 18px 16px 16px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(31, 35, 41, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:active {
    transform: scale(0.985);
    box-shadow: 0 1px 4px rgba(31, 35, 41, 0.08);
  }
}

/* 信息区 */
.stu-info {
  min-width: 0;
}

.stu-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.stu-name {
  font-size: 15px;
  font-weight: 600;
  color: #1f2329;
}

.stu-meta {
  font-size: 12px;
  color: #a0a6ad;
}

.stu-classes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

/* 底部操作区 */
.stu-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f1f3;
}

.stu-actions .van-button {
  flex: 1;
  height: 34px;
  margin: 0;
  padding: 0;
  border-radius: 17px;
  font-size: 14px;
  font-weight: 500;

  &::before {
    display: none;
  }
}

/* 请假：实心主题渐变 */
.leave-btn.van-button {
  border: none;
  color: #fff;
  background: linear-gradient(135deg, #52c1b2 0%, #3aa89a 100%);
  box-shadow: 0 2px 8px rgba(58, 168, 154, 0.32);

  &:active {
    opacity: 0.85;
  }
}

/* 取消请假：柔和红描边 */
.cancel-btn.van-button {
  border: 1px solid #eea2a0;
  color: #e5695f;
  background: #fff;

  &:active {
    opacity: 0.85;
  }
}

/* 报班管理：主题青绿描边 */
.manage-btn.van-button {
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
  background: #fff;

  &:active {
    opacity: 0.85;
  }
}
</style>
